/* @flow */
import React from 'react';

// $FlowFixMe destructuring. Missing annotation
const ListItem = ({ children, ...props }) => <li {...props}>{children}</li>;

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ListItem.jsx